import { render, staticRenderFns } from "./leimu.vue?vue&type=template&id=abfa6b52&scoped=true"
import script from "./leimu.vue?vue&type=script&lang=js"
export * from "./leimu.vue?vue&type=script&lang=js"
import style0 from "./leimu.vue?vue&type=style&index=0&id=abfa6b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfa6b52",
  null
  
)

export default component.exports